'use strict'

import React from 'react';
import './checkbox.scss';

const defaultColor = '#4A4A4A';

function isStringAndColorValue(str) {
    return (typeof str === 'string' || str instanceof String) && str.match(/^#(([a-fA-F]|\w){3}|([a-fA-F]|\w){6})$/gi);
}

function getColors(propsColor) {
    const colors = {};
    const isPropsColor = isStringAndColorValue(propsColor);

    colors.backgroundColor = isPropsColor ? propsColor : defaultColor;
    if (!isPropsColor && isStringAndColorValue(propsColor.backgroundColor)) {
        colors.backgroundColor = propsColor.backgroundColor;
    }

    colors.borderColor = isPropsColor ? propsColor : defaultColor;
    if (!isPropsColor && isStringAndColorValue(propsColor.borderColor)) {
        colors.borderColor = propsColor.borderColor;
    }

    colors.uncheckedBorderColor = isPropsColor ? propsColor : defaultColor;
    if (!isPropsColor && isStringAndColorValue(propsColor.uncheckedBorderColor)) {
        colors.uncheckedBorderColor = propsColor.uncheckedBorderColor;
    }

    colors.tickColor = isStringAndColorValue(propsColor.tickColor)
        ? propsColor.tickColor
        : '#FFFFFF';

    return colors;
}

class Checkbox extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = this.setProps(props)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const data = this.setProps(nextProps)
        this.setState(data)
    }

    setProps(props) {
        return {
            backAnimationDuration: props.backAnimationDuration || 10,
            borderthickness: props.borderthickness || 3,
            checked: props.checked || false,
            isPartiallyChecked: props.isPartiallyChecked || false,
            className: props.className || '',
            color: props.color || {},
            style: props.style || {},
            delay: props.delay || 0,
            id: props.id || '',
            onChange: props.onChange || function () { },
            size: props.size || 2,
            tickAnimationDuration: props.tickAnimationDuration || 100,
            tickSize: props.tickSize || 3,
            disabled: props.disabled || false,
            title: props.title || '',
            propagateEvents: props.propagateEvents || false,
        }
    }

    render() {
        const classes = ['Checkbox'];
        classes.push(this.state.className);
        classes.push(this.state.checked ? 'checked' : 'unchecked');
        if (this.state.disabled) {
            classes.push('disabled')
        }

        const scale = 0.25 + (0.25 * this.state.size);
        const attrId = this.state.id !== '' ? { id: this.state.id } : {};
        const colors = getColors(this.state.color);
        if (this.state.disabled) {
            const gray = '#6b6a74'
            colors.backgroundColor = colors.borderColor = colors.uncheckedBorderColor = gray
        }
        const tickTransitionDelay = 10;
        const squareTransitionDelay = 10;
        return (
            <>
                {!this.props.isPdf &&
                    <div
                        {...attrId}
                        className={classes.join(' ')}
                        role="checkbox"
                        aria-checked="false"
                        tabIndex="0"
                        style={this.state.style}
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            if (this.state.disabled) {
                                return
                            }

                            if (this.state.propagateEvents) {
                                this.state.onChange(e, !this.state.checked);
                            } else {
                                this.state.onChange(!this.state.checked);
                            }
                        }}
                        onKeyPress={(e) => {
                            if (this.state.disabled) {
                                return
                            }

                            if (this.state.propagateEvents) {
                                this.state.onChange(e, !this.state.checked);
                            } else {
                                this.state.onChange(!this.state.checked);
                            }
                        }}
                    >
                        <input title={this.state.title} {...attrId} type="checkbox" style={{ display: 'none' }} />
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            version="1.1"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            transform={`scale(${scale})`}
                        >
                            <rect
                                className="square"
                                x="2"
                                y="2"
                                width="20"
                                height="20"
                                rx="2"
                                ry="2"
                                fill={colors.backgroundColor}
                                stroke={this.state.checked
                                    ? colors.borderColor
                                    : colors.uncheckedBorderColor}
                                strokeWidth={`${this.state.borderthickness}px`}
                                style={{
                                    transitionDelay: `${squareTransitionDelay}ms`,
                                    transitionDuration: `${this.state.backAnimationDuration}ms`,
                                }}
                            />
                            <path
                                className="tick"
                                d={this.state.isPartiallyChecked ? "M 6 6 L 18 18" : "M6,6 v8 h16"}
                                strokeWidth={this.state.tickSize}
                                stroke={colors.tickColor}
                                fill="none"
                                transform="rotate(-45, 12, 12)"
                                style={{
                                    transitionDelay: `${tickTransitionDelay}ms`,
                                    transitionDuration: `${this.state.tickAnimationDuration}ms`,
                                }}
                            />
                        </svg>
                    </div>
                }
            </>
        );
    }
}

export default Checkbox


// WEBPACK FOOTER //
// ./src/common/checkbox/checkbox.component.jsx